import { reduce } from 'lodash'

import {
  computeJsonDescriptorHighlights,
  computeTextDescriptorHighlights,
} from '../../common/helpers'

import { DISH_FIELDS_CONFIG } from '../constants'
import { formatDishMenuTitleOriginFieldPrefix } from '../utils'

const computeDishHighlightsFields = (dish, menuTitleParents) => ({
  [DISH_FIELDS_CONFIG.NAME.value]: dish.name,
  [DISH_FIELDS_CONFIG.DESCRIPTION.value]: dish.description,
  [DISH_FIELDS_CONFIG.INGREDIENTS.value]: dish.ingredients,

  ...computeTextDescriptorHighlights(
    DISH_FIELDS_CONFIG.ADDON_DESCRIPTORS.value,
    dish.addonDescriptors,
  ),
  ...computeTextDescriptorHighlights(
    DISH_FIELDS_CONFIG.ALLERGEN_DESCRIPTORS.value,
    dish.allergenDescriptors,
  ),
  ...computeJsonDescriptorHighlights(
    DISH_FIELDS_CONFIG.DIET_DESCRIPTORS.value,
    dish.dietDescriptors,
  ),

  ...reduce(
    menuTitleParents,
    (acc, menuTitle) => ({
      ...acc,
      [`menuTitleName:${menuTitle.id}`]: menuTitle.title,
      [`menuTitleDescription:${menuTitle.id}`]: menuTitle.description,
      ...computeTextDescriptorHighlights(
        formatDishMenuTitleOriginFieldPrefix(
          DISH_FIELDS_CONFIG.MENU_TITLE_ADDON_DESCRIPTORS.value,
          menuTitle.id,
        ),
        menuTitle.addonDescriptors,
      ),
      ...computeTextDescriptorHighlights(
        formatDishMenuTitleOriginFieldPrefix(
          DISH_FIELDS_CONFIG.MENU_TITLE_ALLERGEN_DESCRIPTORS.value,
          menuTitle.id,
        ),
        menuTitle.allergenDescriptors,
      ),
      ...computeJsonDescriptorHighlights(
        formatDishMenuTitleOriginFieldPrefix(
          DISH_FIELDS_CONFIG.MENU_TITLE_DIET_DESCRIPTORS.value,
          menuTitle.id,
        ),
        menuTitle.dietDescriptors,
      ),
    }),
    {},
  ),
})

export default computeDishHighlightsFields
